import React, { Component } from 'react';
import { Button, Table, Modal, InputGroup, Row, Col} from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
import NewElement from './NewElement';
import Scoring from './Scoring';
import ShowModalPopUp from '../ShowModalPopUp';
export default class Template extends Component {
  constructor(props) {
    super(props)
    this.state = {
      additionalField:[],
      nameExist:false,
      toggleI:true,
      toggleT:false,
      saveAlert:false,
    }
    this.rows={'Parameters':[], 'Additional':[]}
  }
  
  componentDidMount() {
    const{templatepayload} = _.cloneDeep(this.props);
    this.createTemplate(_.cloneDeep(templatepayload.templateValue.Parameters))
   
    if(!_.isEmpty(templatepayload.templateValue.Additional)){
      this.setState({additional:true})
      this.setState({additionalField:templatepayload.templateValue.Additional})
    }
  }
  
  deleteTemplate = (rowIndex, row) => {
    let {templateObj} = this.state;
    if(templateObj.length > 1){
    let {templateObj} = this.state;
    templateObj.splice(rowIndex, 1);
    this.setState({templateObj});
    }
  }
  
  
  
  createTemplate = (json) => { 
    const{dataList} = this.props
    let prop = 'Addtional Fields'
   // let isparamVisited = false
   // let isAttribVisited = false
    let templateObj = [];
    let payload = [];
    payload["Parameters"] = dataList.Parameters;
    payload["Attributes"] = dataList.Attributes;
    payload["Questions"] = dataList.Questions;
    payload["Additional"] = dataList[prop];
    payload["Scoring"] = dataList;
    _.map(json, (obj, paramindex) => {   
       // isparamVisited = true   
      _.map(obj.attributes, (val, index) => {
       //   isAttribVisited = true
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            // let isParamDisable = ((isparamVisited === false) || (isAttribVisited === false)) ? true : false;
            // let isAttribDisable = (isAttribVisited === false) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            //tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            //tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
          });
         // isparamVisited = false
          //isAttribVisited = false
        });
      });
    });
    this.setState({ templateObj, payload });
  }

  createNewTemplate = (row, rowIndex) => {  
    let {templateObj} = this.state;
    let newRow = _.cloneDeep(templateObj[0]);
    newRow.key = "K" + templateObj.length;
    newRow.Parameters.value = {};
    newRow.Parameters.disabled = null
    newRow.Attributes.value = {};
    newRow.Attributes.disabled = null
    newRow.Questions.value = {};
    newRow.Questions.disabled = null
    newRow.Scoring.value = {"min": "0", "weight": "", "max":""};
   // newRow.Scoring.disabled = null
    // templateObj.push(newRow);
    templateObj.splice(rowIndex+1, 0, newRow);
    this.setState({templateObj});
  } 
  CallbackFunctionScoring = (rowIndex, obj, identity) =>{  
    const {templateObj} = this.state;
    templateObj[rowIndex].Scoring.value = obj
    this.setState({templateObj})
    this.setState({saveAlert:true})
    if(identity == 'NCReasons'){
      this.setState({ncAlert:true})
    }
  }
  onCloseSaveAlert = () => {
    this.setState({saveAlert:false})
    window.scrollTo(0, document.body.scrollHeight);
  }
  CallbackFunctionParamm = (obj, rowIndex) =>{
    const {templateObj} = this.state;
    templateObj[rowIndex].Parameters.value = obj
    this.setState({templateObj})
  }
  CallbackFunctionAttrib = (obj, rowIndex) =>{
    const {templateObj} = this.state;
    templateObj[rowIndex].Attributes.value = obj
    this.setState({templateObj})
  }
  NewRenderCallbackFunction(row, obj, rowIndex) {
    const {templateObj} = this.state;
    let last = templateObj[rowIndex]
    last.Questions.value = obj
    let lastid = last.Parameters.value.id;
    if(_.isEqual(row.Parameters.value.label, last.Parameters.value.label)){
        row.Parameters.value.id = lastid; 
    } else {
      row.Parameters.value.id = lastid+1; 
    }
    this.setState({templateObj})
  }
 
  renderBody = () => {
    const {templateObj, payload} = this.state;
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        return (
          <tr className='FormTemplate' key={row.key}>
            <td><NewElement Callback={this.CallbackFunctionParamm} index={rowIndex} row={row} value={row.Parameters.value} payload={payload.Parameters} disabled={row.Parameters.disabled}
              id={row.Parameters.id} /></td>
            <td><NewElement Callback={this.CallbackFunctionAttrib} index={rowIndex} row={row} value={row.Attributes.value} payload={payload.Attributes} disabled={row.Attributes.disabled}
              id={row.Attributes.id} /></td>
            <td><NewElement Callback={(a, b)=>this.NewRenderCallbackFunction(row, a, b)} index={rowIndex} value={row.Questions.value} payload={payload.Questions}
              id={row.Questions.id} /></td>
            <td><Scoring CallbackFunctionScoring={this.CallbackFunctionScoring} index={rowIndex} value={row.Scoring.value} payload={payload.Scoring}
              id={row.Scoring.id} /></td>
             <td><i class='fas fa-plus-circle accord' onClick={()=>this.createNewTemplate(row, rowIndex)} />
              <i class="fas fa-times-circle accord" onClick={() => this.deleteTemplate(rowIndex, row)} />
            </td> 
          </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );
  }
  additionalFields = (e) => {    
    this.setState({additional:e.target.checked})
    if(e.target.checked === false){
      this.setState({additionalField:[]})
    }
  }
  createNewField = (obj, e) => {
    let additionalFields = this.state.additionalField 
    let xIndex = _.findIndex(additionalFields,{'id':obj.id})
    if(e.target.checked){
      let x = _.find(additionalFields, obj);      
      if(_.isEmpty(x)){
        additionalFields.push(obj)
      }
    } else {
      _.pullAt(additionalFields, xIndex)
    }
    this.setState({additionalField:additionalFields})    
  }
  handleAdditionalBody = () => {
    const {payload, additional, additionalField} = this.state;
    const{templatepayload} = this.props;
    let firstcol=[], secondCol=[], thirdcol=[];
    if(additional){
      _.map(payload.Additional, (obj, i)=> {        
        if(obj.label === 'Drop Down'){
          //let selDrop = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          let selDrop = _.find(additionalField, {'id':obj.id})
          let options = []
          _.map(obj.additionalValues, (obj1) =>{
            if(obj1['status']  !== 'INACTIVE'){
              options.push(obj1)
            }
          })
          firstcol.push(    
         <Col md={3} className='marginBottom'>&nbsp; 
         <input type='CheckBox' checked={!_.isEmpty(selDrop) ? selDrop  : false} 
            onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b>
            <Picky keepOpen={false}
            value={[]}
            options={options}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select'
            dropdownHeight={600}
            />     
         </Col>
         ) }
        if(obj.label === 'Text Area'){
          //let seltext = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          let seltext = _.find(additionalField, {'id':obj.id})
          secondCol.push(    
            <Col md={3} className='marginBottom template'>&nbsp;  
           <input type='CheckBox' checked={!_.isEmpty(seltext) ? seltext  : false} 
           onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b><br/>                 
           </Col>
           ) 
        }
        if(obj.label === 'Text Box'){
          //let selArea = _.find(templatepayload.templateValue.Additional, {'id':obj.id})
          let selArea = _.find(additionalField, {'id':obj.id})
          thirdcol.push(    
            <Col md={3} className='marginBottom '>&nbsp; 
           <input type='CheckBox' checked={!_.isEmpty(selArea) ? selArea  : false} 
           onChange={(e)=>this.createNewField(obj,e)}/>&nbsp;<b>{obj.labelObj}</b>          
           </Col>
           ) 
        }        
        }) 
        return  (<div className='aditionalModification'>  
          <span><b>Drop Down</b></span>
         <hr/>       
         <Row>{firstcol}</Row>
         <span><b>Text Area</b></span>
         <hr/>
         <Row>{secondCol}</Row>
         <span><b>Text Box</b></span>
         <hr/>
         <Row>{thirdcol}</Row>
        
         </div>)
    } 
  }
  saveUpdateChanges = () => {
    let ismandatoryChecked = this.mandatoryNewChanges()
    if(ismandatoryChecked === false){
      this.setState({reconfirm:true})   
    }
  }
  handleHideSaveReconfirm = () => {
    this.setState({reconfirm:false})
  }
  createSaveTemplate = () => {    
    let ismandatoryChecked = this.mandatoryNewChanges()
    if(ismandatoryChecked === false){
      this.setState({saveNew:true})   
    }
  }
  handleHideSave = () => {
    this.setState({saveNew:false})
  }
  mandatoryNewChanges = () => {
    const {templateObj} = this.state;
    let object =[]
    object  =  _.filter(templateObj, (row) =>{
      if(_.has(row.Scoring.value, 'textRating') && row.Scoring.value.textRating === true){
        return  (
          (_.isEmpty(row.Parameters.value['label'])  || _.isEmpty(row.Parameters.value))  || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Attributes.value['label']) || _.isEmpty(row.Attributes.value))   || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Questions.value['label']) || _.isEmpty(row.Questions.value))     || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Scoring.value.weight)) || _.isNull(row.Scoring.value.min) 
        )
      } else {
        return  (
          (_.isEmpty(row.Parameters.value['label'])  || _.isEmpty(row.Parameters.value))  || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Attributes.value['label']) || _.isEmpty(row.Attributes.value))   || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Questions.value['label']) || _.isEmpty(row.Questions.value))     || row.Parameters.value['label'] === "null" ||
          (_.isEmpty(row.Scoring.value.weight)) || _.isNull(row.Scoring.value.min) ||  _.isNull(row.Scoring.value.max) 
          ||  _.isEmpty(row.Scoring.value.max)
        )
      }
    })
    if(_.isEmpty(object)){
      this.setState({mandatorySection:false})    
      return false
    } else {
      this.setState({mandatorySection:true})
      return true
    }
  }  
  handleChangeName= (e) => {    
    this.setState({tempname:e.target.value})
  } 
  mandatorySectionFalse = () => {
    this.setState({mandatorySection:false})
  }
  mandatoryModal = () => {
    return(<Modal show={true}
    onHide={this.mandatorySectionFalse}
    dialogClassName="modal-90w shadowClass"
    size='md'
    aria-labelledby="contained-modal-title-vcenter"
    centered>   
    <Modal.Body>
     Please fill mandatory Sections
    </Modal.Body>
    <Modal.Footer>
      <Button className='buttonwidth' onClick={this.mandatorySectionFalse}> OK </Button>
    </Modal.Footer>
    </Modal>)
    
  }
  saveModal = (prop, close) => {
    
    let content;
    if(prop) {
      content = (
        <InputGroup><InputGroup.Prepend>
       <InputGroup.Text id="basic-addon1"><i class="fas fa-comment"></i>
       </InputGroup.Text>
       </InputGroup.Prepend><input  className='form-control'
        onChange={(e)=>this.handleChangeName(e)} placeholder='Template Name'
        value={this.state.tempname} type='text'/></InputGroup>   
      )
    } else {
      content = (
        <p>Content of Template has been Modified need to Save the changes</p>  
      )
    }
    return(<Modal show={true}
    onHide={close}
    dialogClassName="modal-90w shadowClass"
    size='md'
    aria-labelledby="contained-modal-title-vcenter"
    centered>          
    <Modal.Header closeButton><Modal.Title>Save changes
    </Modal.Title>
    </Modal.Header>
    <Modal.Body>
     {content}
     {this.state.nameExist ? <p className='RedColoring alignRight'>{'Template Name already Exist'}</p> : null
     }
    </Modal.Body>
    <Modal.Footer>
    {(prop) ?
      <Button className='buttonwidth' onClick={this.finalNew} disabled={_.isEmpty(this.state.tempname)}> OK </Button>
      : <div>
      <Button className='buttonwidth' onClick={this.saveChanges}> OK </Button> &nbsp;
      <Button className='buttonwidth' onClick={this.props.closeModal}> Cancel </Button>

    </div> }
    </Modal.Footer>
    </Modal>)
    
  }
  finalNew = () => { 
    let cc;
    if(!_.isEmpty(this.props.nameList)){
    cc =this.props.nameList.filter(obj => 
      _.includes(obj.templateName.toLowerCase(), this.state.tempname.toLowerCase()))
    }
    if(_.isEmpty(cc)){
      this.newJson(this.state.templateObj)
      this.handleHideSave()
      this.props.closeModal()
      this.rows.Additional.push(...this.state.additionalField)     
      this.props.function.TokenValidation()        
      this.props.function.activetemplateAdd(this.rows, this.state.tempname)  
    } else {
      this.setState({nameExist:true})
    } 
  }
  saveChanges = () => {       
    this.newJson(this.state.templateObj)    
    this.props.closeModal()
    this.rows.Additional.push(...this.state.additionalField)   
    this.props.function.TokenValidation()  
    this.props.function.activetemplateEdit(this.props.templatepayload.templateName, this.rows, 
      _.cloneDeep(this.props.templatepayload))
  }
  discardChanges = () => {
    this.props.closeModal()
  }  
  newJson(template){
    _.remove(template, (obj) =>{return (_.isEmpty(obj.Parameters.value) || _.isEmpty(obj.Parameters.value['label']))})
    let n = template.length-1
    for(let i=0;i<=n;i++){
      if(i === 0){
        let newRow = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
        newRow.id = template[i].Parameters.value.id;
        newRow.label = template[i].Parameters.value.label;
        newRow.attributes =[{'label':template[i].Attributes.value.label, 'questions':[]}]
        newRow.attributes[0].questions = [{'label':template[i].Questions.value.label, 'Scoring':[]}]
        newRow.attributes[0].questions[0].Scoring = [template[i].Scoring.value]
        this.rows.Parameters.push(newRow)
      } else {
        
        if(!_.isEqual(template[i].Parameters.value.label, template[i-1].Parameters.value.label)){
          
       
          let next = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
          if(_.isEmpty(next)){
            let newRow = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
            newRow.id = template[i].Parameters.value.id;
            newRow.label = template[i].Parameters.value.label;
            newRow.attributes =[{'label':template[i].Attributes.value.label, 'questions':[]}]
            newRow.attributes[0].questions = [{'label':template[i].Questions.value.label, 'Scoring':[]}]
            newRow.attributes[0].questions[0].Scoring = [template[i].Scoring.value] 
            this.rows.Parameters.push(newRow)
          } else {
             let newtemp = _.find(next.attributes, {'label':template[i].Attributes.value.label})
             if(!_.isEmpty(newtemp)){
              newtemp.questions.push({'label':template[i].Questions.value.label, 
              'Scoring':[template[i].Scoring.value]})
            } else {
             next.attributes.push({'label':template[i].Attributes.value.label, 
            'questions':[{'label':template[i].Questions.value.label, 'Scoring':[template[i].Scoring.value]}]})
            }
          }
        } else {
          if(_.isEqual(template[i].Attributes.value.label, template[i-1].Attributes.value.label)){
            let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
            if(!_.isEmpty(newRow)){
              let newRow1 = _.find(newRow.attributes, {label: template[i].Attributes.value.label})    
              if(!_.isEmpty(newRow1)) {     
                newRow1.questions.push({'label':template[i].Questions.value.label, 
                'Scoring':[template[i].Scoring.value]}) 
              }
              
            } else {
              let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
              row.label = template[i].Parameters.value.label;
              row.id  = template[i].Parameters.value.id;
              row.attributes =[]
              row.attributes.push(        
                {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
                'Scoring':[template[i].Scoring.value]}]})
                this.rows.Parameters.push(row)
            }
  
          } else {
             let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
              if(!_.isEmpty(newRow)){
                newRow.attributes.push(        
                {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
                'Scoring':[template[i].Scoring.value]}]})
              }
              else{
                let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
                row.label = template[i].Parameters.value.label;
                row.id  = template[i].Parameters.value.id;
                row.attributes =[]
                row.attributes.push(        
                {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
                'Scoring':[template[i].Scoring.value]}]})
                this.rows.Parameters.push(row)
              }
  
          }
          
        }
      }
    }
    // if( n === 0) {
    //   let next = _.find(this.rows.Parameters, {label: template[0].Parameters.value.label})
    //       if(_.isEmpty(next)){
    //         let newRow = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //         newRow.id = template[0].Parameters.value.id;
    //         newRow.label = template[0].Parameters.value.label;
    //         newRow.attributes =[{'label':template[0].Attributes.value.label, 'questions':[]}]
    //         newRow.attributes[0].questions = [{'label':template[0].Questions.value.label, 'Scoring':[]}]
    //         newRow.attributes[0].questions[0].Scoring = [template[0].Scoring.value]
    //         this.rows.Parameters.push(newRow)
    //     }
    // } else {
    // for(let i =0; i<=n; i++){   
    //   if( i === n ){
    //     if(!_.isEqual(template[i].Parameters.value.label, template[i-1].Parameters.value.label)){
    //       let next = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //       if(_.isEmpty(next)){
    //         let newRow = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //         newRow.id = template[i].Parameters.value.id;
    //         newRow.label = template[i].Parameters.value.label;
    //         newRow.attributes =[{'label':template[i].Attributes.value.label, 'questions':[]}]
    //         newRow.attributes[0].questions = [{'label':template[i].Questions.value.label, 'Scoring':[]}]
    //         newRow.attributes[0].questions[0].Scoring = [template[i].Scoring.value]
    //         this.rows.Parameters.push(newRow)
    //       } else {
    //          let newtemp = _.find(next.attributes, {'label':template[i].Attributes.value.label})
    //          if(!_.isEmpty(newtemp)){
    //           newtemp.questions.push({'label':template[i].Questions.value.label, 
    //           'Scoring':[template[i].Scoring.value]})
    //         } else {
    //          next.attributes.push({'label':template[i].Attributes.value.label, 
    //         'questions':[{'label':template[i].Questions.value.label, 'Scoring':[template[i].Scoring.value]}]})
    //         }
    //       }
    //     } else {
    //       if(_.isEqual(template[i].Attributes.value.label, template[i-1].Attributes.value.label)){
    //         let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //         if(!_.isEmpty(newRow)){ 
    //           let newRow1 = _.find(newRow.attributes, {label: template[i].Attributes.value.label}) 
    //           if(!_.isEmpty(newRow1)){       
    //             newRow1.questions.push({'label':template[i].Questions.value.label, 
    //             'Scoring':[template[i].Scoring.value]})      
    //           }        
    //         } else {
    //           let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //           row.label = template[i].Parameters.value.label;
    //           row.id  = template[i].Parameters.value.id;
    //           row.attributes =[]
    //           row.attributes.push(        
    //             {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //             'Scoring':[template[i].Scoring.value]}]})
    //             this.rows.Parameters.push(row)
    //         }
  
    //       } else {
    //          let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //           if(!_.isEmpty(newRow)){
    //             newRow.attributes.push(        
    //             {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //             'Scoring':[template[i].Scoring.value]}]})
    //           }
    //           else{
    //             let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //             row.label = template[i].Parameters.value.label;
    //             row.id  = template[i].Parameters.value.id;
    //             row.attributes =[]
    //             row.attributes.push(        
    //             {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //             'Scoring':[template[i].Scoring.value]}]})
    //             this.rows.Parameters.push(row)
    //           }
    //       }
          
    //     }
    //   }  


    //   else{
    //   if(!_.isEqual(template[i].Parameters.value.label, template[i+1].Parameters.value.label)){
    //     let next = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //     if(_.isEmpty(next)){
    //       let newRow = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //       newRow.id = template[i].Parameters.value.id;
    //       newRow.label = template[i].Parameters.value.label;
    //       newRow.attributes =[{'label':template[i].Attributes.value.label, 'questions':[]}]
    //       newRow.attributes[0].questions = [{'label':template[i].Questions.value.label, 'Scoring':[]}]
    //       newRow.attributes[0].questions[0].Scoring = [template[i].Scoring.value] 
    //       this.rows.Parameters.push(newRow)
    //     } else {
    //        let newtemp = _.find(next.attributes, {'label':template[i].Attributes.value.label})
    //        if(!_.isEmpty(newtemp)){
    //         newtemp.questions.push({'label':template[i].Questions.value.label, 
    //         'Scoring':[template[i].Scoring.value]})
    //       } else {
    //        next.attributes.push({'label':template[i].Attributes.value.label, 
    //       'questions':[{'label':template[i].Questions.value.label, 'Scoring':[template[i].Scoring.value]}]})
    //       }
    //     }
    //   } else {
    //     if(_.isEqual(template[i].Attributes.value.label, template[i+1].Attributes.value.label)){
    //       let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //       if(!_.isEmpty(newRow)){
    //         let newRow1 = _.find(newRow.attributes, {label: template[i].Attributes.value.label})    
    //         if(!_.isEmpty(newRow1)) {     
    //           newRow1.questions.push({'label':template[i].Questions.value.label, 
    //           'Scoring':[template[i].Scoring.value]}) 
    //         }
            
    //       } else {
    //         let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //         row.label = template[i].Parameters.value.label;
    //         row.id  = template[i].Parameters.value.id;
    //         row.attributes =[]
    //         row.attributes.push(        
    //           {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //           'Scoring':[template[i].Scoring.value]}]})
    //           this.rows.Parameters.push(row)
    //       }

    //     } else {
    //        let newRow = _.find(this.rows.Parameters, {label: template[i].Parameters.value.label})
    //         if(!_.isEmpty(newRow)){
    //           newRow.attributes.push(        
    //           {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //           'Scoring':[template[i].Scoring.value]}]})
    //         }
    //         else{
    //           let row = _.cloneDeep(this.props.templatepayload.templateValue.Parameters[0])
    //           row.label = template[i].Parameters.value.label;
    //           row.id  = template[i].Parameters.value.id;
    //           row.attributes =[]
    //           row.attributes.push(        
    //           {'label':template[i].Attributes.value.label, 'questions':[{'label':template[i].Questions.value.label, 
    //           'Scoring':[template[i].Scoring.value]}]})
    //           this.rows.Parameters.push(row)
    //         }

    //     }
        
    //   }
    //   }
    //   }
  }
  handleadditionalInformation = () =>{
    this.setState((prevState) =>{
      return {toggleT: !prevState.toggleT};
    })
  } 
  handleTemplate  = () =>{
    this.setState((prevState) =>{
      return {toggleI: !prevState.toggleI};
    })
  } 
  render() {
    const{additional, toggleT, toggleI, saveNew,reconfirm, mandatorySection, saveAlert, ncAlert} = this.state;
    return (
         <div>
          <span className="RedColoring alignRight">* indicates Required field &nbsp; &nbsp; 
          <i class="fas fa-times" onClick={this.props.closeModal}></i></span><br/>
          <h6 className={toggleI ? 'evalFormMargin': 'evalForm'} onClick={this.handleTemplate}>
          {toggleI ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b>
              ASSESMENT TEMPLATE</b> </h6>
          <div className={toggleI ? 'assesmentShow': 'assesmentHide'}>           
            <Table responsive>
              <thead>
                <tr>
                  <th>PARAMETERS<span className="RedColoring"> *</span></th>
                  <th>ATTRIBUTES<span className="RedColoring"> *</span></th>
                  <th>QUESTIONS<span className="RedColoring"> *</span></th>
                  <th>SCORING ENTITY</th>   
                  <th style={{'padding':'0px'}}></th>               
                </tr>
              </thead>
              <tbody>
                {
                  this.renderBody()
                }
              </tbody>
            </Table>
            </div>
            <span className='alignRight'>*** Choose additional values whichever is applicable for the template</span>
            <div className='clearBoth'>            
              <h6 className={toggleT ? 'evalFormMargin': 'evalForm'} onClick={this.handleadditionalInformation}>
              {toggleT ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b>&nbsp;
              <input type='Checkbox' checked={additional} onChange={this.additionalFields}/>&nbsp;
              ADDITIONAL INFORMATION</b></h6>
              <div className={toggleT ? 'assesmentShow': 'assesmentHide'}>  
              { this.handleAdditionalBody() }
              </div>
            </div>
            {this.props.edit === true ? <p className='alignRight'>
            <Button className='buttonwidth' size='md' onClick={this.saveUpdateChanges}>SAVE</Button> &nbsp; &nbsp;
            <Button className='buttonwidth'size='md'  onClick={this.createSaveTemplate}>SAVE AS</Button> </p> 
            :<Button className='alignRight buttonwidth' size='md' onClick={this.createSaveTemplate}>SAVE AS</Button>}           
            {(saveNew === true && mandatorySection === false ) ? this.saveModal(true, this.handleHideSave) : null }
            {(reconfirm  === true && mandatorySection === false) ? this.saveModal(false, this.handleHideSaveReconfirm) : null }
            {mandatorySection ? this.mandatoryModal() : null }
            {saveAlert && ncAlert?
              <ShowModalPopUp message={'Please click SAVE button to permanently save your NCReasons'} 
              falseShowModalPopUp={this.onCloseSaveAlert}/>
            :null}
          </div>
    )
  }
}